import apiClient from './apiClient';

const unwrap = async (request, fallbackMessage) => {
  try { return (await request).data.data; }
  catch (error) {
    const body = error?.response?.data;
    const formatted = new Error(body?.error?.message || body?.message || error?.message || fallbackMessage);
    // The decision UI must distinguish a rejected review (for example 403 or
    // LOCAL_AUTHORITY_STALE_REVIEW) from a lost response with an unknown save
    // outcome. Preserve that contract without forwarding Axios request/config,
    // response headers or arbitrary backend details that may contain secrets.
    formatted.code = body?.error?.code || body?.code || error?.code || null;
    formatted.status = error?.response?.status || null;
    throw formatted;
  }
};

const financialTermsService = {
  history: (params) => unwrap(apiClient.get('/admin/financial-terms', { params }), 'Financial terms could not be loaded'),
  decideLocalAuthority: (employeeId, body) => unwrap(
    apiClient.post(`/admin/financial-terms/employees/${employeeId}/local-authority`, body),
    'Financial authority decision could not be saved'
  ),
};
export default financialTermsService;
